import { useState } from 'react';
import { useRequestData } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';

/**
 * Tracks the active slide and fires the carousel move event. Shared by the
 * mobile Slider ('swiped') and the desktop carousel ('clicked'), which differ
 * only in the reported action.
 *
 * @param {object} params
 * @param {string} params.trackEventElement - tracked element name
 * @param {string} params.pageAlias - current page alias
 * @param {string} params.action - 'swiped' or 'clicked'
 * @returns {{ activeSlide: number, afterSlide: (index: number) => void }}
 */
export const useCarouselTracking = ({
	trackEventElement,
	pageAlias,
	action
}) => {
	const [activeSlide, setActiveSlide] = useState(0);
	const { windowId, widgetName } = useRequestData();

	const afterSlide = (index) => {
		trackEvent(widgetName, windowId, {
			pageAlias,
			element: trackEventElement,
			result: `Moved to vehicle ${index + 1}`,
			action,
			previousIndex: activeSlide,
			currentIndex: index
		});
		setActiveSlide(index);
	};

	return { activeSlide, afterSlide };
};
